import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { FormattedMessage } from 'react-intl'
import * as bootupSelectors from 'services/bootup/selectors'
import styles from './_privacyStyles.css'

const mapStateToProps = (state) => ({
  accountPortalRoot: bootupSelectors.selectAccountPortalRoot(state),
  customerSupportLink: bootupSelectors.selectCustomerSupportLink(state),
})

function WebFooter (props) {
  const termsLink = `${props.accountPortalRoot}/terms-and-conditions`
  const privacyLink = `${props.accountPortalRoot}/privacy`

  return (
    <div className={styles.webFooterWrapper}>
      <div className={styles.webFooter}>
        <a href={termsLink} rel="noopener noreferrer" target='_blank'>
          <FormattedMessage
            id='privacy_center.footer.terms_of_service'
            defaultMessage='Terms of Service'
          />
        </a>
        <a href={privacyLink} rel="noopener noreferrer" target='_blank'>
          <FormattedMessage
            id='privacy_center.footer.privacy_policy'
            defaultMessage='Privacy Policy'
          />
        </a>
        <a href={props.customerSupportLink} rel="noopener noreferrer" target='_blank'>
          <FormattedMessage
            id='privacy_center.footer.contact_us'
            defaultMessage='Contact Us'
          />
        </a>
      </div>
    </div>
  )
}

WebFooter.propTypes = {
  accountPortalRoot: PropTypes.string,
  customerSupportLink: PropTypes.string,
}

export default connect(mapStateToProps, {})(WebFooter)
